import { createSvgIcon } from '@material-ui/core';

export const DragActiveIcon = createSvgIcon(
  <svg viewBox="0 0 18 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(0, 2.5)">
      <rect
        x="0.5"
        y="0.5"
        width="17"
        height="30"
        rx="3.5"
        fill="white"
        stroke="#E0E0E0"
      />
      <path
        d="M6 7H8V9H6V7ZM10 7H12V9H10V7ZM6 11H8V13H6V11ZM10 11H12V13H10V11ZM6 15H8V17H6V15ZM10 15H12V17H10V15ZM6 19H8V21H6V19ZM10 19H12V21H10V19ZM6 23H8V25H6V23ZM10 23H12V25H10V23Z"
        fill="currentColor"
      />
    </g>
  </svg>,
  'DragActiveIcon',
);
